import Cookies from 'js-cookie';

export function getCookie(key) {
	return Cookies.get(key);
}

export function setCookie(key, value, expires) {
	return Cookies.set(key, value, { expires: expires });
}

export function removeCookie(key) {
	return Cookies.remove(key);
}

// User
const TokenKey = 'Admin-Token';
export const getToken = () => Cookies.get(TokenKey);
export const setToken = (token) => Cookies.set(TokenKey, token);
export const removeToken = () => Cookies.remove(TokenKey);

const ExpiresInKey = 'Admin-Expires-In';
export function getExpiresIn() {
	return Cookies.get(ExpiresInKey) || -1;
}

export function setExpiresIn(time) {
	return Cookies.set(ExpiresInKey, time);
}

export function removeExpiresIn() {
	return Cookies.remove(ExpiresInKey);
}
